export default function DashboardTopbar() {
    return (
        <div className="bg-white border-b px-6 py-4 flex justify-between items-center">
            <h1 className="text-xl font-semibold text-gray-800">
                Article Dashboard
            </h1>

            <div className="text-sm text-gray-600">
                Logged in as <span className="font-semibold">Admin</span>
            </div>
        </div>
    );
}
